<template>
  <!-- 登录页面 -->
  <div>
    <Row class="container">
      <i-col span="13" offset="2" class="login-img-box"> </i-col>
      <i-col span="7" class="login-box">
        <div class="login-container">
          <div class="login-header">
            <p>找回密码</p>
          </div>
          <div class="form-box">
            <Form ref="formInline" :model="formDate" :rules="ruleInline">
              <FormItem prop="account">
                <i-input
                  type="text"
                  v-model="formDate.account"
                  clearable
                  size="large"
                  placeholder="用户名"
                >
                  <Icon type="person" slot="prepend"></Icon>
                </i-input>
              </FormItem>
              <FormItem prop="captcha">
                <i-input
                  v-model="formDate.captcha"
                  size="large"
                  placeholder="请输入验证码"
                >
                  <Icon type="ios-locked" slot="prepend"> </Icon>
                  <Button
                    slot="append"
                    :disabled="disabled"
                    :class="disabled === true ? 'on' : ''"
                    @click="getcheckNum"
                  >
                    {{ text }}
                  </Button>
                </i-input>
              </FormItem>
              <FormItem prop="password">
                <i-input
                  type="password"
                  v-model="formDate.password"
                  clearable
                  size="large"
                  placeholder="请输入新密码"
                >
                  <Icon type="ios-locked-outline" slot="prepend"> </Icon>
                </i-input>
              </FormItem>
              <FormItem>
                <Button
                  type="error"
                  size="large"
                  @click="handleSubmit('formInline')"
                  long
                  >确认</Button
                >
              </FormItem>
            </Form>
            <div class="forget-box">
              <div>
                <router-link to="/login">
                  立即登录
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { registerVerify, registerReset } from "@api/user";
import sendVerifyCode from "@/mixins/SendVerifyCode";
export default {
  name: "RetrievePassword",
  data() {
    return {
      formDate: {
        account: "",
        captcha: "",
        password: ""
      },
      ruleInline: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码不能少于6位",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mixins: [sendVerifyCode],
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          registerReset(this.formDate)
            .then(() => {
              this.$Message.success({
                content: "修改密码成功",
                duration: 6,
                closable: true
              });
              this.router.push({
                path: "/login"
              });
            })
            .catch(err => {
              this.$Message.error({
                content: err.msg,
                duration: 6,
                closable: true
              });
            });
        }
      });
    },
    getcheckNum() {
      if (this.formDate.account.length === 11) {
        const data = {
          phone: this.formDate.account
        };
        registerVerify(data).then(res => {
          if (res.status === 200) {
            this.$Message.success({
              content: "验证码已发送",
              duration: 6,
              closable: true
            });
            this.sendCode();
          }
        });
      } else {
        this.$Message.error({
          content: "请输入正确的手机号",
          duration: 6,
          closable: true
        });
      }
    }
  }
};
</script>

<style scoped>
.container {
  margin-bottom: -30px;
  background-color: #fff;
  background-image: url("/assets/pc/images/home/login.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.login-img-box {
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-img-box > img {
  width: 68%;
}
.login-box {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-container {
  width: 80%;
  height: 330px;
  background: #fff;
  border-radius: 3%;
}
.login-header {
  height: 60px;
  font-size: 20px;
  text-align: left;
  line-height: 60px;
  letter-spacing: 2px;
  color: #333;
  margin-left: 30px;
  margin-top: 10px;
}
.form-box {
  width: 80%;
  margin: 0 auto;
}
.forget-box {
  margin-top: -10px;
}
.forget-box div:first-child {
  color: #f60000;
  text-align: center;
}
.on {
  color: #fff;
  background: #999;
}
</style>
